import { Injectable } from '@angular/core'
import { delay } from 'rxjs/operators'
import { ParseService } from '../../parse.service'

declare global {
    interface Window {
        pintrk?: (a: 'track', b: 'lead' | 'checkout' | 'addtocart' | 'pagevisit', c: unknown) => void
    }
}

@Injectable({
    providedIn: 'root',
})
export class PinterestTagService {
    constructor(private parseService: ParseService) {
        const subscription = this.parseService.user
            // ensures subscription has a value before unsubscribing
            .pipe(delay(0))
            .subscribe((user) => {
                try {
                    if (user) {
                        this.trackPageVisit().catch((err) => {})

                        subscription.unsubscribe()
                    }
                } catch (err) {
                    this.parseService.reportUIError(err, 'PinterestTagService.constructor', JSON.stringify({ userID: user?.id }))
                }
            })
    }

    public trackLead() {
        try {
            if (!window.pintrk) {
                return
            }

            window.pintrk('track', 'lead', {
                lead_type: 'Not Specified',
            })
        } catch (err) {
            this.parseService.reportUIError(err, 'PinterestTagService.trackLead', '')
        }
    }

    public trackCheckout(val: number, currency: 'USD') {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (!window.pintrk || val <= 0) {
                return
            }

            window.pintrk('track', 'checkout', {
                product_id: 'the-product-id',
                order_id: '' + Date.now(),
                value: val,
                currency,
            })
        } catch (err) {
            this.parseService.reportUIError(err, 'PinterestTagService.trackCheckout', '')
        }
    }

    public async trackAddToCart() {
        try {
            if (!window.pintrk) {
                return
            }
            window.pintrk('track', 'addtocart', {
                product_id: 'the-product-id',
            })
        } catch (err) {
            this.parseService.reportUIError(err, 'PinterestTagService.trackAddToCart', '')
        }
    }

    private async trackPageVisit() {
        try {
            if (!window.pintrk) {
                return
            }
            window.pintrk('track', 'pagevisit', {
                product_id: 'the-product-id',
            })
        } catch (err) {
            this.parseService.reportUIError(err, 'PinterestTagService.trackPageVisit', '')
        }
    }
}
